import { SwitchAppButton } from "../../../components";
import { Link } from "react-router-dom";

import tickCircleBlueIcon from "../../../assets/icons/tick-circle-blue.svg";
import { IOnboardingStep6ViewProps } from "./OnboardingStep6";
import { OnboardingCompletedModal } from "./OnboardingCompletedModal";

export const View = ({
  isLoadingRequestAccountActivation,
  isSuccessRequestAccountActivation,
  requestAccountActivation,
  handlePrevious,
  handleComplete,
}: IOnboardingStep6ViewProps) => {
  return (
    <>
      {/* <div className="onboarding-section onboarding-step-6 flex-box flex-container col justify-content--between"> */}
      <div className="onboarding-section onboarding-step-6 flex-box">
        <div className="flex-box flex-container justify-content--center align-items--center">
          <div className="flex-container justify-content--center align-items--center">
            <div className="onboarding-section__header">
              <img src={tickCircleBlueIcon} alt="onboarding complete icon" />
            </div>

            <div className="flex-container col align-items--center">
              <h3 className="step-title font-ctm--bold">Setup Complete</h3>
              <div className="feedback-request--description font-ctm--semibold text-secondary">
                <p>
                  Click the button below to request for the activation of your
                  account.
                </p>
                <p>Our team will verify the details you have provided.</p>
                <p>
                  If everything is okay, we will activate your account for
                  payouts.
                </p>
                <br />
                <br />
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>

        <p className="switchapp-legal--container switchapp-legal-agreements">
          By activating your profile you agree with the{" "}
          <Link to="/terms-of-service">Terms and Conditions</Link>,{" "}
          <Link to="/privacy-policy">Privacy Policy</Link> and{" "}
          <Link to="/privacy#cookie-policy">Cookie Policy</Link> of
          <b className="company-name font-ctm--bold">
            {" "}
            SwitchApp Tech Solutions Limited.
          </b>
        </p>

        <div className="flex-container buttons-container">
          <SwitchAppButton
            className="onboarding-previous--button"
            kind="secondary"
            onClick={handlePrevious}
          >
            Previous
          </SwitchAppButton>

          <SwitchAppButton
            className="switchapp-themed onboarding-submit--button"
            size="sm"
            isLoading={isLoadingRequestAccountActivation}
            onClick={requestAccountActivation}
          >
            Request Activation
          </SwitchAppButton>
        </div>
      </div>

      <OnboardingCompletedModal
        isModalOpen={isSuccessRequestAccountActivation}
        closeModal={handleComplete}
      />
    </>
  );
};
